import type { RequestProps } from "../../../../request/request";
import { request } from "../../../../request/request";
import { campaignDonorsResponseSchema } from "./schema/givingCampaignDonorsSchema";

export type RequestCommunitiesAdminCampaignDonorsProps = Omit<
  RequestProps,
  "url"
> & {
  communityId: number;
  campaignId: number;
  pageParam: number;
  perPage?: number;
};

export const ADMIN_CAMPAIGN_DONORS_PAGE_SIZE = 25;
export const ADMIN_CAMPAIGN_DONORS_MAX_PAGE_SIZE = 200;

export const requestCommunitiesAdminCampaignDonors = ({
  communityId,
  campaignId,
  pageParam,
  perPage = ADMIN_CAMPAIGN_DONORS_PAGE_SIZE,
  ...props
}: RequestCommunitiesAdminCampaignDonorsProps) =>
  request({
    ...props,
    schema: campaignDonorsResponseSchema,
    urlBackendPath: `/communities/${communityId}/admin/campaigns/${campaignId}/donors?page=${pageParam}&per_page=${perPage}`,
  });
